import React, { useEffect, useState } from "react";
// import { getInfo } from '../../slice/workerInfoSlice';
import { useDispatch, useSelector } from "react-redux";
import { storeProviderBenefitsStability } from "../../slice/provider_benefit_stabilitySlice";
import { toast } from "react-toastify";
// import { submitBenefitsIntake } from '../services/benefitsApi';

const STATES = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

const PRIORITY_CATEGORIES = [
    'Health Coverage Navigation',
    'ICHRA / QSEHRA Readiness',
    'Retirement Readiness',
    'Supplemental Protection',
    'Financial Wellness',
    'Mental Health / EAP Support',
    'Education / CDA / Workforce Training',
    'Benefits Communication for Staff'
];

const WORKFORCE_CHALLENGES = [
    'Staff turnover',
    'Recruiting qualified employees',
    'Benefits affordability',
    'Part-time staff coverage',
    'Onboarding paperwork',
    'Employee financial stress',
    'Training/credential tracking',
    'No current benefits structure'
];

const emptyForm = {
    provider_name: '',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    state: 'VA',
    provider_type: '',
    staff_count: '',
    current_health_coverage: '',
    benefits_budget_status: '',
    priority_categories: [],
    workforce_challenges: [],
    current_vendors: [],
    open_enrollment_urgency: '',
    ichra_qsehra_interest: '',
    retirement_interest: '',
    supplemental_interest: '',
    financial_wellness_interest: '',
    mental_health_interest: '',
    education_training_interest: '',
    preferred_follow_up: '',
    notes: ''
};

function toggleArrayValue(current, value) {
    return current.includes(value) ? current.filter((item) => item !== value) : [...current, value];
}

export default function BenefitsStabilityIntake() {

    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const [currentStep, setCurrentStep] = useState(1);
    const [openStep, setOpenStep] = useState(1);
    const totalSteps = 6;

    const { userData } = useSelector((state) => state.workerInfo);

    const [form, setForm] = useState(emptyForm);
    const [loading, setLoading] = useState(false);
    const [acknowledged, setAcknowledged] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(null);
    const [isAutoFilled, setIsAutoFilled] = useState(false);

    const update = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    useEffect(() => {
        if (!userData) return;

        setForm((prev) => ({
            ...prev,
            provider_name: userData.business_name || '',
            contact_name: `${userData.first_name || ''} ${userData.last_name || ''}`.trim(),
            contact_email: userData.email || '',
            contact_phone: userData.phone || '',
            state: userData.states || 'VA',
        }));

        setIsAutoFilled(true);
    }, [userData]);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!acknowledged) {
            toast.error("Please acknowledge before submitting.");
            return;
        }

        setLoading(true);
        setError('');
        setSuccess(null);

        dispatch(storeProviderBenefitsStability({ token, form }))
            .unwrap()
            .then((res) => {
                toast.success(res?.message || "Submitted successfully");
                setSuccess(res?.data);
                setForm(emptyForm);
                setAcknowledged(false);
            })
            .catch((err) => {
                toast.error(err?.message || "Failed");
                setError(err?.message || "Something went wrong");
            })
            .finally(() => {
                setLoading(false); // ✅ THIS FIXES YOUR ISSUE
            });
    };

    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                        Benefits Stability Intake
                    </h4>
                    <section className="mb-4">
                        <p className="lead mb-2">
                            Help NCAF understand your workforce stability needs so we can organize the right benefits navigation, education, and pilot follow-up.
                        </p>
                        <div className="alert alert-info">
                            NCAF provides workforce-benefits navigation and coordination support. NCAF does not act as an insurer, broker, fiduciary, employer of record, or state agency.
                        </div>
                    </section>

                    {error && <div className="alert alert-danger">{error}</div>}
                    {success && (
                        <div className="alert alert-success">
                            <strong>Submitted.</strong> Intake #{success.id} is now marked as <strong>{success.pilot_status}</strong>. {success.next_step}
                        </div>
                    )}
                    <div className="mb-4">
                        <div className="d-flex justify-content-between mb-2">
                            <small>Step {currentStep} of {totalSteps}</small>
                            <small>{Math.round((currentStep / totalSteps) * 100)}% Completed</small>
                        </div>

                        <div className="progress">
                            <div
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                    width: `${(currentStep / totalSteps) * 100}%`
                                }}
                            />
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="accordion" id="benefitsAccordion">

                            {/* STEP 1 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button ${openStep !== 1 ? 'collapsed' : ''}`}
                                        type="button"
                                        onClick={() => {
                                            setOpenStep(openStep === 1 ? null : 1);
                                            setCurrentStep(1);
                                        }}
                                    >
                                        Provider Profile
                                    </button>
                                </h2>

                                <div
                                    id="step1"
                                    className={`accordion-collapse collapse ${openStep === 1 ? 'show' : ''}`}
                                    data-bs-parent="#benefitsAccordion"
                                >
                                    <div className="accordion-body">

                                        <h2 className="h5 mb-4">Provider / Contact</h2>
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label">Provider / Center Name</label>
                                                <input className="form-control" value={form.provider_name} onChange={(e) => update('provider_name', e.target.value)} disabled={isAutoFilled} />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Contact Name</label>
                                                <input className="form-control" value={form.contact_name} onChange={(e) => update('contact_name', e.target.value)} disabled={isAutoFilled} />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Contact Email *</label>
                                                <input type="email" required className="form-control" value={form.contact_email} onChange={(e) => update('contact_email', e.target.value)} disabled={isAutoFilled} />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Contact Phone</label>
                                                <input className="form-control" value={form.contact_phone} onChange={(e) => update('contact_phone', e.target.value)} disabled={isAutoFilled} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">State *</label>
                                                <select required className="form-select" value={form.state} disabled={isAutoFilled} onChange={(e) => update('state', e.target.value)}>
                                                    {STATES.map((state) => <option key={state} value={state}>{state}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Provider Type</label>
                                                <select className="form-select" value={form.provider_type} onChange={(e) => update('provider_type', e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option>Licensed Childcare Center</option>
                                                    <option>Family / Home-Based Childcare</option>
                                                    <option>Religious / Exempt / Informal Care</option>
                                                    <option>Multi-site Provider</option>
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Approximate Staff Count</label>
                                                <select className="form-select" value={form.staff_count} onChange={(e) => update('staff_count', e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option>1-5</option>
                                                    <option>6-15</option>
                                                    <option>16-30</option>
                                                    <option>31-75</option>
                                                    <option>76+</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* STEP 2 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button ${openStep !== 2 ? 'collapsed' : ''}`}
                                        type="button"
                                        onClick={() => {
                                            setOpenStep(openStep === 2 ? null : 2);
                                            setCurrentStep(2);
                                        }}
                                    >
                                        Current Benefits
                                    </button>
                                </h2>

                                <div
                                    id="step2"
                                    className={`accordion-collapse collapse ${openStep === 2 ? 'show' : ''}`}
                                    data-bs-parent="#benefitsAccordion"
                                >
                                    <div className="accordion-body">

                                        <h2 className="h5 mb-4">Benefits Priorities</h2>
                                        <p>Select all that apply.</p>
                                        <div className="row g-2">
                                            {PRIORITY_CATEGORIES.map((item) => (
                                                <div className="col-md-6" key={item}>
                                                    <label className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            checked={form.priority_categories.includes(item)}
                                                            onChange={() => update('priority_categories', toggleArrayValue(form.priority_categories, item))}
                                                        />
                                                        <span className="form-check-label">{item}</span>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* STEP 3 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button ${openStep !== 3 ? 'collapsed' : ''}`}
                                        type="button"
                                        onClick={() => {
                                            setOpenStep(openStep === 3 ? null : 3);
                                            setCurrentStep(3);
                                        }}
                                    >
                                        Benefits Priorities
                                    </button>
                                </h2>

                                <div
                                    id="step3"
                                    className={`accordion-collapse collapse ${openStep === 3 ? 'show' : ''}`}
                                    data-bs-parent="#benefitsAccordion"
                                >
                                    <div className="accordion-body">
                                        <h2 className="h5 mb-4">Current Situation</h2>
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label">Current Health Coverage Situation</label>
                                                <select className="form-select" value={form.current_health_coverage} onChange={(e) => update('current_health_coverage', e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option>No current group health option</option>
                                                    <option>Some employees use ACA marketplace</option>
                                                    <option>Employer offers group health</option>
                                                    <option>Considering ICHRA/QSEHRA</option>
                                                    <option>Not sure</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Benefits Budget Status</label>
                                                <select className="form-select" value={form.benefits_budget_status} onChange={(e) => update('benefits_budget_status', e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option>No budget yet</option>
                                                    <option>Small monthly contribution possible</option>
                                                    <option>Budget exists but needs structure</option>
                                                    <option>Need partner pricing first</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Open Enrollment Urgency</label>
                                                <select className="form-select" value={form.open_enrollment_urgency} onChange={(e) => update('open_enrollment_urgency', e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option>Immediate / within 30 days</option>
                                                    <option>Within 60-90 days</option>
                                                    <option>Planning for next cycle</option>
                                                    <option>Not tied to open enrollment</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Preferred Follow-Up</label>
                                                <select className="form-select" value={form.preferred_follow_up} onChange={(e) => update('preferred_follow_up', e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option>Email summary</option>
                                                    <option>Phone call</option>
                                                    <option>Virtual meeting</option>
                                                    <option>Pilot partner introduction</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* STEP 4 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button ${openStep !== 4 ? 'collapsed' : ''}`}
                                        type="button"
                                        onClick={() => {
                                            setOpenStep(openStep === 4 ? null : 4);
                                            setCurrentStep(4);
                                        }}
                                    >
                                        Workforce Challenges
                                    </button>
                                </h2>

                                <div
                                    id="step4"
                                    className={`accordion-collapse collapse ${openStep === 4 ? 'show' : ''}`}
                                    data-bs-parent="#benefitsAccordion"
                                >
                                    <div className="accordion-body">
                                        <h2 className="h5 mb-4">Workforce Challenges</h2>
                                        <div className="row g-2">
                                            {WORKFORCE_CHALLENGES.map((item) => (
                                                <div className="col-md-6" key={item}>
                                                    <label className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            checked={form.workforce_challenges.includes(item)}
                                                            onChange={() => update('workforce_challenges', toggleArrayValue(form.workforce_challenges, item))}
                                                        />
                                                        <span className="form-check-label">{item}</span>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* STEP 5 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button ${openStep !== 5 ? 'collapsed' : ''}`}
                                        type="button"
                                        onClick={() => {
                                            setOpenStep(openStep === 5 ? null : 5);
                                            setCurrentStep(5);
                                        }}
                                    >
                                        Readiness
                                    </button>
                                </h2>

                                <div
                                    id="step5"
                                    className={`accordion-collapse collapse ${openStep === 5 ? 'show' : ''}`}
                                    data-bs-parent="#benefitsAccordion"
                                >
                                    <div className="accordion-body">
                                        <h2 className="h5 mb-4">Interest Level by Category</h2>
                                        <div className="row g-3">
                                            {[
                                                ['ichra_qsehra_interest', 'ICHRA / QSEHRA'],
                                                ['retirement_interest', 'Retirement'],
                                                ['supplemental_interest', 'Supplemental Protection'],
                                                ['financial_wellness_interest', 'Financial Wellness'],
                                                ['mental_health_interest', 'Mental Health / EAP'],
                                                ['education_training_interest', 'Education / Training']
                                            ].map(([field, label]) => (
                                                <div className="col-md-6" key={field}>
                                                    <label className="form-label">{label}</label>
                                                    <select className="form-select" value={form[field]} onChange={(e) => update(field, e.target.value)}>
                                                        <option value="">Select</option>
                                                        <option>High priority</option>
                                                        <option>Interested but not urgent</option>
                                                        <option>Need education first</option>
                                                        <option>Not needed now</option>
                                                    </select>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* STEP 6 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button ${openStep !== 6 ? 'collapsed' : ''}`}
                                        type="button"
                                        onClick={() => {
                                            setOpenStep(openStep === 6 ? null : 6);
                                            setCurrentStep(6);
                                        }}
                                    >
                                        Consent & Submit
                                    </button>
                                </h2>

                                <div
                                    id="step6"
                                    className={`accordion-collapse collapse ${openStep === 6 ? 'show' : ''}`}
                                    data-bs-parent="#benefitsAccordion"
                                >
                                    <div className="accordion-body">
                                        <h2 className="h5 mb-4">Notes</h2>
                                        <div className="row g-3">
                                            <div className="col-12">
                                                <textarea
                                                    className="form-control"
                                                    rows="5"
                                                    value={form.notes}
                                                    onChange={(e) => update('notes', e.target.value)}
                                                    placeholder="Anything else NCAF should know before follow-up?"
                                                />
                                            </div>

                                            <div className="col-12">
                                                <div className="border rounded p-3 bg-light">
                                                    <div className="d-flex align-items-start">
                                                        <input
                                                            className="form-check-input mt-1 me-2 flex-shrink-0"
                                                            type="checkbox"
                                                            id="acknowledgment"
                                                            checked={acknowledged}
                                                            onChange={(e) => setAcknowledged(e.target.checked)}
                                                        />

                                                        <label
                                                            htmlFor="acknowledgment"
                                                            className="small mb-0"
                                                            style={{ lineHeight: "1.5" }}
                                                        >
                                                            I understand NCAF provides education, readiness screening,
                                                            workforce interest collection, structured reporting, and
                                                            referral routing. NCAF does not recommend, sell, quote,
                                                            enroll, bind, administer, or determine eligibility for
                                                            insurance, reimbursement arrangements, health plans,
                                                            retirement plans, or employee benefit programs.
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-auto">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-lg"
                                                    disabled={loading || !acknowledged}
                                                >
                                                    {loading ? 'Submitting...' : 'Submit Benefits Stability Intake'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}
